import SelectDebtAmount from './SelectDebtAmount';

export default SelectDebtAmount;